/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_3_DInputs */

const en_cp_who_3_d = /** @type {(inputs: Cp_Who_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ready program with a calendar, rubric, and end-of-semester report. Anchor it to the grant season, national competitions, or your society's internal selection.`)
};

const id_cp_who_3_d = /** @type {(inputs: Cp_Who_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program siap pakai dengan kalender, rubrik, dan laporan akhir per semester. Cocok dijangkarkan ke musim PKM, P2MW, Gemastik, atau seleksi internal himpunan.`)
};

/**
* | output |
* | --- |
* | "A ready program with a calendar, rubric, and end-of-semester report. Anchor it to the grant season, national competitions, or your society's internal selection." |
*
* @param {Cp_Who_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_3_d = /** @type {((inputs?: Cp_Who_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_3_d(inputs)
	return en_cp_who_3_d(inputs)
});